import { IJobType } from './job-type';
import { ProjectStatus } from './project-status';
import { Employee} from './employee';
import { IClientEngineer } from './client-engineer';
import { IInstallationProgress } from './installation-progress';
import { Invoice } from './invoice';
import { MaterialProcurementStatus } from './material-procurement-status';
import { Company } from './company';
import { EmployeeBase } from './employee-base';

export class Project{
  id: number = 0;
  projectNo: string;
  description: string;
  jobType: IJobType;
  projectStatus: ProjectStatus;
  responsibleEngineer: Employee;
  client?: Company;
  clientEngineers?: IClientEngineer[];
  quotingDeadline?: Date;
  
  materialProcurementStatus?: MaterialProcurementStatus;
  materialEstimateDeliveryDate?: Date
  materialActualArrivalDate?: Date
  materialStatusMemo?: string;
  
  installationProgress?: IInstallationProgress;
  invoices?: Invoice[]; //should be dropdown
  totalInvoiceValue?: number; // calculated from invoices
  completionPercentage?: number;
  targetStartDate?: Date
  targetCompletionDate?: Date
  budgetHour?: number;
  plannedHour?: number;
  actualHour?: number;

  earnedManHours?: number;

  workOrder?: string;
  contractNumber?: string;
  bankGuaranteeAmount?: number;
  bankGuaranteeExpirationDate?: Date

  poNumber?: string;
  poAmount?: number;
  estimatedCompletionValue?: number;

  commentBy?: EmployeeBase;
  commentDate?: Date;
  comment?: string;

  hasAttachment?: boolean;

  directLabor?: number;
  plantAndEquipment?: number;
  materialsAndConsumbles?: number;
  management?: number;
  thirdParty?: number;
}

